const BUTTON_STYLES = {
  primary: "primary",
  secondary: "secondary",
  tertiary: "tertiary",
  danger: "danger",
  danger_text: "danger_text",
  text: "text",
  link: "link",
};

const SIZES = { small: "small", medium: "medium", large: "large" };

const STRATEGY = { absolute: "absolute", fixed: "fixed" };

const MENU_ITEM_TYPES = { menuItem: "menuItem", divider: "divider" };

const DEFAULT_TOOLTIP_PROPS = {
  disabled: true,
  position: "bottom",
  touch: ["hold", 500],
};

const ICON_SIZES = { small: 20, medium: 24, large: 30 };

const STYLE_TO_VARIANT = {
  primary: "default",
  secondary: "secondary",
  tertiary: "ghost",
  danger: "destructive",
  danger_text: "destructive",
  text: "ghost",
  link: "link",
};

export {
  BUTTON_STYLES,
  SIZES,
  STRATEGY,
  MENU_ITEM_TYPES,
  DEFAULT_TOOLTIP_PROPS,
  ICON_SIZES,
  STYLE_TO_VARIANT,
};
